import MaterialIcons from '@expo/vector-icons/build/MaterialIcons';
import Entypo from '@expo/vector-icons/Entypo';
import { StyleSheet, TouchableOpacity, View } from 'react-native';
import { Divider } from 'react-native-paper';

import Text from '@/components/Text';

interface FieldArrayListItemAmenityCardProps {
  onPress: () => void;
  onDelete: () => void;
  title: string;
}

const FieldArrayListItemAmenityCard = ({ onPress, onDelete, title }: FieldArrayListItemAmenityCardProps) => (
  <TouchableOpacity onPress={onPress}>
    <View style={styles.mainContainer}>
      <View style={styles.container}>
        <View style={styles.textGap}>
          <Text fontWeight="700" style={styles.black}>
            {title}
          </Text>
        </View>
        <View style={styles.buttonsContainer}>
          <TouchableOpacity onPress={onDelete}>
            <MaterialIcons name="delete" size={24} color="red" />
          </TouchableOpacity>
          <Entypo name="chevron-thin-right" size={24} color="black" />
        </View>
      </View>

      <Divider />
    </View>
  </TouchableOpacity>
);

const styles = StyleSheet.create({
  mainContainer: {
    gap: 15,
    justifyContent: 'center',
    marginBottom: 15
  },

  container: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },

  buttonsContainer: {
    flexDirection: 'row',
    gap: 25
  },

  textGap: {
    gap: 2
  },

  black: {
    color: 'black'
  }
});

export default FieldArrayListItemAmenityCard;
